import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ElementRef,
  ViewChild,
} from '@angular/core'
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  FormControlName,
} from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import { AuthService, User } from '@spartacus/core'
import { Router } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import { of, Observable } from 'rxjs'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { DeliveryAddress, BillToAddress } from '../../model/address-models'
import { NgSelectComponent } from '@ng-select/ng-select'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { environment } from '../../../../../../environments/environment'
import { QuoteStatus } from '../../../../../models/status/status.model'
import { CommonService } from '../../../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-ship-to-address',
  templateUrl: './ship-to-address.component.html',
  styleUrls: ['./ship-to-address.component.scss'],
})
export class ShipToAddressComponent implements OnInit, OnChanges {
  @Input() isSubmitted = false
  @Input() selectedAddress: any
  @Input() deliveryAddress: DeliveryAddress
  @Input() billToAddress: BillToAddress
  @Input() count = 1
  @Input() validationGroup = 'delivery'
  @Input() quoteCartType
  @Output() deliveryAddressUpdate = new EventEmitter<DeliveryAddress>()
  @Output() getSoldToAddress = new EventEmitter<boolean>()
  @ViewChild('countryFocus') countryFocus: NgSelectComponent
  @ViewChild('stateFocus') stateFocus: NgSelectComponent
  shipToAddress: FormGroup
  countryNames: any
  selectedCountry: any
  countryRegionNames: any
  isSoldToAddress = false
  company: string
  userType: string
  user$: Observable<User>
  isLoggedinUser = false
  cartId: string
  isSelectAddress = false

  userAddressData: any
  userAddressData$: Observable<any>
  componentAddress = 'Ship To'
  cartName = 'rfqcart'
  public radioSelected: string
  public newAdd: boolean
  public userRoles = 'userRoles'
  public term: string

  userAddressList: any
  selectedShipAddress: {
    firstName: any
    lastName: any
    companyName: any
    line1: any
    town: any
    name: any
    postalCode: any
  }
  selectedState: any
  shipData: any
  countryData: any
  stateData: any
  billToValidation: boolean
  isSumittedObs: boolean
  QuoteStatus = QuoteStatus
  maxVal: number

  constructor(
    private quoteCheckoutService: QuoteCheckoutService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private data: QuoteDataService,
    private auth: AuthService,

    private router: Router,
    private quoteService: QuoteCartService,
    private quoteDataService: QuoteDataService, // private el: ElementRef,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.quoteDataService.recieveBillToAddressValidation.subscribe(
      (valid: boolean) => {
        this.billToValidation = valid
      }
    )
    this.shipToAddressFormDetails()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          this.maxVal = 40
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          this.maxVal = 35
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
        this.maxVal = 40
        this.cartId = sessionStorage.getItem('cartId-current')
        this.cartId = this.cartId
          ? this.cartId
          : sessionStorage.getItem('cartId-current')

        this.data.sendShipToAddressValidation(true)
      } else {
        this.userType = 'anonymous'
        this.maxVal = 35
        this.cartId = sessionStorage.getItem('cartId-anonymous')
        this.cartId = this.cartId
          ? this.cartId
          : sessionStorage.getItem('cartId-anonymous')
      }
      // this.getUserAddress();
    })
    this.shipToAddress.valueChanges.subscribe((data) => {
      if (!this.isSoldToAddress) {
        this.data.sendShipToAddressValidation(this.shipToAddress.valid)
      }
      if (this.isSoldToAddress) {
        this.data.sendShipToAddressValidation(true)
      }
      this.deliveryAddress = {
        country: this.countryData,
        companyName: data.companyName,
        line1: data.line1,
        line2: data.line2,
        postalCode: data.postalCode,
        town: data.city,
        region: this.stateData,
      }
      this.deliveryAddressUpdate.emit(this.deliveryAddress)
    })
    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      if (
        data === true &&
        this.shipToAddress.invalid &&
        this.billToValidation
      ) {
        this.scrollToError()
      }
    })
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )

    this.scrollTo(firstElementWithError)
  }
  ngOnChanges(changes) {
    if (this.isSoldToAddress) {
      this.stateData = this.billToAddress.region
      this.isSubmitted = false
      this.shipToAddress.patchValue({
        line1: this.billToAddress?.line1,
        companyName: this.billToAddress?.companyName,
        line2: this.billToAddress?.line2,
        country: this.billToAddress?.country?.name,
        postalCode: this.billToAddress?.postalCode,
        state: this.billToAddress?.region?.name,
        city: this.billToAddress?.town,
      })
      this.deliveryAddress = this.billToAddress

      this.data.sendShipToAddressValidation(this.shipToAddress.valid)
      this.shipToAddress.disable()
    }
  }
  shipToAddressFormDetails() {
    this.shipToAddress = this.formBuilder.group({
      companyName: new FormControl('', Validators.required),
      line1: new FormControl('', Validators.required),
      line2: new FormControl(''),
      country: new FormControl(null, Validators.required),
      state: new FormControl(null),
      city: new FormControl('', Validators.required),
      postalCode: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9 -]*$/),
        ],
      ],
    })
    let checkCopySoldToAddressToshipToAddressCheckBoxValue
    this.quoteCheckoutService.copySoldToAddressToshipToAddressCheckBoxValue.subscribe(
      (data) => {
        checkCopySoldToAddressToshipToAddressCheckBoxValue = data
      }
    )

    if (this.userType === 'current') {
      if (this.deliveryAddress) {
        this.isSubmitted = false
        this.shipToAddress.patchValue({
          line1: this.billToAddress?.line1,
          companyName: this.billToAddress?.companyName,
          line2: this.billToAddress?.line2,
          country: this.billToAddress?.country?.name
            ? this.billToAddress?.country?.name
            : '',
          postalCode: this.billToAddress?.postalCode,
          state: this.billToAddress?.region?.name
            ? this.billToAddress?.region?.name
            : '',
          city: this.billToAddress?.town,
        })

        this.data.sendShipToAddressValidation(this.shipToAddress.valid)
        this.shipToAddress.updateValueAndValidity()
      } else {
      }
    } else {
      if (
        this.deliveryAddress &&
        checkCopySoldToAddressToshipToAddressCheckBoxValue
      ) {
        this.isSubmitted = false
        this.shipToAddress.patchValue({
          line1: this.billToAddress?.line1,
          companyName: this.billToAddress?.companyName,
          line2: this.billToAddress?.line2,
          country: this.billToAddress?.country?.name
            ? this.billToAddress?.country?.name
            : '',
          postalCode: this.billToAddress?.postalCode,
          state: this.billToAddress?.region?.name
            ? this.billToAddress?.region?.name
            : '',
          city: this.billToAddress?.town,
        })

        this.data.sendShipToAddressValidation(this.shipToAddress.valid)
        this.shipToAddress.updateValueAndValidity()
      } else if (
        this.deliveryAddress &&
        !checkCopySoldToAddressToshipToAddressCheckBoxValue
      ) {
        this.isSubmitted = false
        this.shipToAddress.patchValue({
          line1: this.deliveryAddress?.line1,
          companyName: this.deliveryAddress?.companyName,
          line2: this.deliveryAddress?.line2,
          country: this.deliveryAddress?.country?.name
            ? this.deliveryAddress?.country?.name
            : '',
          postalCode: this.deliveryAddress?.postalCode,
          state: this.deliveryAddress?.region?.name
            ? this.deliveryAddress?.region?.name
            : '',
          city: this.deliveryAddress?.town,
        })

        this.data.sendShipToAddressValidation(this.shipToAddress.valid)
        this.shipToAddress.updateValueAndValidity()
      }
    }
    this.getCountryData()
  }
  get companyName() {
    return this.shipToAddress.get('companyName')
  }
  get line1() {
    return this.shipToAddress.get('line1')
  }
  get country() {
    return this.shipToAddress.get('country')
  }
  get state() {
    return this.shipToAddress.get('state')
  }
  get city() {
    return this.shipToAddress.get('city')
  }
  get postalCode() {
    return this.shipToAddress.get('postalCode')
  }
  getCountryData() {
    const countries = 'countries'
    const urlParam = [countries]
    const apiUrl = this.commonService.constructUrl(urlParam)
    // const apiParams = { fields: 'DEFAULT', type: 'SHIPPING' };
    const apiParams = { fields: 'DEFAULT' }

    this.commonService.getData(apiUrl, apiParams).subscribe(
      (success) => {
        this.countryNames = success[countries]
      },
      (error) => {}
    )
  }

  toggleSoldToAddress() {
    if (!this.isSoldToAddress) {
      this.quoteCheckoutService.copySoldToAddressToshipToAddressCheckBoxValue.next(
        false
      )
      this.deliveryAddress = null
      this.shipToAddress.reset()
      this.shipToAddress.enable()
    } else {
      this.quoteCheckoutService.copySoldToAddressToshipToAddressCheckBoxValue.next(
        true
      )
      this.shipToAddress.controls['line1'].setValue(this.billToAddress?.line1)
      this.shipToAddress.controls['companyName'].setValue(
        this.billToAddress?.companyName
      )
      this.shipToAddress.controls['line2'].setValue(this.billToAddress?.line2)
      this.shipToAddress.controls['country'].setValue(
        this.billToAddress?.country?.name
      )
      this.shipToAddress.controls['postalCode'].setValue(
        this.billToAddress?.postalCode
      )
      this.shipToAddress.controls['city'].setValue(this.billToAddress?.city)
      this.shipToAddress.controls['state'].setValue(this.billToAddress?.town)
      this.deliveryAddress = this.billToAddress
      this.countryData = this.billToAddress.country
      this.deliveryAddressUpdate.emit(this.deliveryAddress)
      this.shipToAddress.disable()
    }
  }
  saveCountryData() {
    this.countryNames.forEach((element) => {
      if (element.isocode === this.shipToAddress.controls['country'].value) {
        this.countryData = element
        this.deliveryAddress.country = element
        // this.shipToAddress.controls.country.setValue(this.shipToAddress.controls.country.value);
      }
    })
    this.selectedCountry = this.shipToAddress.controls['country'].value

    if (this.selectedCountry == 'CN') {
      this.shipToAddress.controls['postalCode'].clearValidators()
    } else {
      this.shipToAddress.controls['postalCode'].setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
        Validators.pattern(/^[a-zA-Z0-9 -]*$/),
      ])
    }
    this.shipToAddress.controls['postalCode'].updateValueAndValidity()
    const regions = 'regions'
    this.commonService
      .getData(
        environment.occBaseUrl +
          environment.getCountryURL +
          this.selectedCountry +
          '/regions?fields=DEFAULT'
      )
      .subscribe(
        (success) => {
          this.countryRegionNames = success[regions]
          if (this.countryRegionNames?.length > 0) {
            this.shipToAddress.controls['state'].setValidators([
              Validators.required,
            ])
          } else {
            this.shipToAddress.controls['state'].clearValidators()
          }
          this.shipToAddress.controls['state'].updateValueAndValidity()
        },
        (error) => {}
      )
  }

  addAddress() {
    this.newAdd = true
  }
  selectedAdd(event) {
    this.selectedAddress = event
    this.deliveryAddress = event
    this.deliveryAddressUpdate.emit(this.deliveryAddress)
    this.closeForm(false)
  }
  closeForm(event) {
    this.isSelectAddress = event
  }

  getUserAddress() {
    if (this.userType === 'current') {
      this.cartId = sessionStorage.getItem('cartId-current')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-current')
    }
    if (this.userType === 'anonymous') {
      this.cartId = sessionStorage.getItem('cartId-anonymous')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-anonymous')
    }
  }
  selectAddress() {
    this.isSelectAddress = true
  }
  closeAdd(flag) {
    this.isSelectAddress = flag
  }
  selectState() {
    this.countryRegionNames.forEach((element) => {
      if (element.isocode === this.shipToAddress.controls['state'].value) {
        this.stateData = element

        this.deliveryAddress.region = element
        this.shipToAddress.controls['state'].setValue(
          this.shipToAddress.controls['state'].value
        )
      }
    })
  }
  acceptNumberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 43 &&
      charCode !== 45 &&
      charCode !== 40 &&
      charCode !== 41 &&
      charCode !== 46 &&
      charCode !== 62
    ) {
      return false
    }
    return true
  }
}
